import * as React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { FormatService } from 'src/core/services/format.service';

interface Props extends ComponentViewProps<DataSet<TourItineraryDateItem>> {
	mode: ControlMode;
	languageCode: string;
	onCreateItem: () => Promise<void>;
	onEditItem: (item: TourItineraryDateItem) => Promise<void>;
}

@observer
export class TourItineraryDateListView extends React.Component<Props, {}> {
	@resolve
	private formatService: FormatService;

	onClickCloneButton = (item: TourItineraryDateItem): void => {
		// TODO: CLONE TourItineraryDate
	};

	render(): React.ReactNode {
		const {
			model,
			onCreateItem,
			onEditItem,
			mode,
			languageCode,
			setBusy,
		} = this.props;
		const columns: Column[] = [
			{
				title: '',
				key: 'clone',
				dataIndex: 'clone',
				className: 'pt-0 pb-0',
				width: '10%',
				render: (field: any, record: TourItineraryDateItem) => (
					<Button
						icon="plus-circle-o"
						onClick={() => this.onClickCloneButton(record)}
						disabled={this.props.mode === 'display' || (record.id == null || record.id < 0)}
					>
						Clone
					</Button>
				)
			},
			{
				title: '#',
				key: 'id',
				dataIndex: 'id',
				width: '30%',
			},
			{
				title: 'Title',
				key: 'displayName',
				dataIndex: 'dynamicProperties',
				width: '30%',
				render: (field: any, record: TourItineraryDateItem) =>
					record.dynamicProperties.displayName[languageCode]
			},
			{
				title: 'Start On',
				key: 'dateFrom',
				dataIndex: 'dateFrom',
				width: '30%',
				render: (field: Date, record: TourItineraryDateItem) =>
					this.formatService.toString('date', field, 'utc')
			}
		];

		return (
			<DataTableView
				model={model}
				columns={columns}
				mode={mode}
				setBusy={setBusy}
				createNewItem={onCreateItem}
				itemDoubleClick={onEditItem}
				hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/list/tour-itinerary-date-list.view.tsx